module.exports = __webpack_public_path__ + "media/images/shop/icon-mindset-364516fedb22ac338f8abd3016dc10de.svg";